import React from 'react'
import { Route } from 'react-router-dom';

const PublicRoutes = ({ component: Component, ...restOfProps }) => {
    return (
        <Route
          {...restOfProps}
          render={(props) =>
            <>
             <Component {...props} />  
         
             </>
          }
        />
      );
}

export default PublicRoutes